import { createAsyncThunk, isRejectedWithValue } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const createRFPProjectInformationAsync = createAsyncThunk(
  'rfxManagement/rfp/createProjectInformationAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/create-new-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const whitelistIpAsync = createAsyncThunk(
  'rfxManagement/rfx/whitelistIpAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/whitelist-ip', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const editRFPProjectInformationAsync = createAsyncThunk(
  'rfxManagement/rfp/createProjectInformationAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/edit-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getTagsAndColorsAsync = createAsyncThunk(
  'rfxAnalysis/getTagsAndColorsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfx-analysis/get-tags-and-colors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRFPFileDataAsync = createAsyncThunk(
  'rfxManagement/rfp/getRFPFileDataAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-analysis-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const deleteTagsAndColorsAsync = createAsyncThunk(
  'rfxManagement/rfp/deleteTagsAndColorsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/delete-vendor-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getTagsAsync = createAsyncThunk(
  'rfxManagement/rfp/getTagsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getBidAnalysisKPIsAsync = createAsyncThunk(
  'rfxManagement/rfp/getBidAnalysisKPIsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-bid-analysis-kpis', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getRFPFiltersDataAsync = createAsyncThunk(
  'rfxManagement/rfp/getRFPFiltersDataAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-filters-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSavingsByPartsAsync = createAsyncThunk(
  'rfxManagement/rfp/getSavingsByPartsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/savings-by-parts', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSasTokenAsync = createAsyncThunk(
  'rfxManagement/rfp/getSasTokenAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfx-analysis/get-sas-token', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getSavingByBidSupplierAsync = createAsyncThunk(
  'rfxManagement/rfp/getSavingByBidSupplierAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/saving-by-bid-supplier', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getSavingAgainstIncumbentAsync = createAsyncThunk(
  'rfxManagement/rfp/getSavingAgainstIncumbentAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/saving-againts-incumbent', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const saveProductViewScenarioAsync = createAsyncThunk(
  'rfxManagement/rfp/saveProductViewScenarioAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/save-product-view-scenario', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getScenarioNames = createAsyncThunk(
  'rfxManagement/rfp/getScenarioNames',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-scenario-names', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getScenarioData = createAsyncThunk(
  'rfxManagement/rfp/getScenarioData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-scenario-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProjectsDetailsAsync = createAsyncThunk(
  'rfxManagement/rfp/getProjectsDetailsAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-project-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// RFI project details KPIs
export const getRFPProjectDetailsKPIsAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-project-details-kpi', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadVendorBidFileAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/download-vendor-bid-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/download-vendor-bid-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getInvalidBidReasonsAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/get-invalid-bid-reasons',
  (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return AxiosClient('POST', '/v1/rfp-analysis/get-invalid-bid-reasons', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Upload Vendors
export const uploadVendorsAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/upload-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-suppliers', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Download consolidated file
export const downloadConsolidatedRFPAsync = createAsyncThunk(
  'rfxManagement/rfi/rfp-analysis/get-consolidated-bids',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-consolidated-bids', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get consolidation status
export const getConsolidationStatusAsync = createAsyncThunk(
  'rfxManagement/rfi/rfp-analysis/get-consolidation-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-consolidation-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//generate consolidation again
export const generateConsolidation = createAsyncThunk(
  'rfxManagement/rfi/project-details/genarate-consolidated-bids',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/genarate-consolidated-bids', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Async for send RFP mail
export const sendRFPEmailAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/sendRFPEmailAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/send-rfp-mail', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const sendRFPEmailCommunicationAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/send-communication',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/send-communication', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const sendRFPTestMailAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/send-test-mail',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/send-test-mail', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Async for Table in project deatil page
export const getProjectVendorsDataAsync = createAsyncThunk(
  'rfxManagement/rfp/project-details/get-all-vendor-details-with-responses',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      'v1/rfp-analysis/get-all-vendor-details-with-responses',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

//Get uploaded vendor error status
export const downloadVendorsWithErrorsStatus = createAsyncThunk(
  'rfxManagement/rfp/project-details/download-vendors-with-errors-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/check-file-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Download uploaded vendors with errors
export const downloadVendorsWithErrors = createAsyncThunk(
  'rfxManagement/rfp/project-details/download-vendors-with-errors-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-supplier-upload-error-file',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//project round
export const GetProjectRoundAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-project-round',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-project-rounds', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//shortlist vendors
export const ShortlistVendorsAsync = createAsyncThunk(
  'rfxManagement/rfp/shortlist-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/vendor-selection-for-nextRound', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//shortlist vendors
export const ShortlistVendorAsync = createAsyncThunk(
  'rfxManagement/rfp/shortlist-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/vendor-shortlist', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//add vendors to rfp
export const AddVendorsToRFPProject = createAsyncThunk(
  'rfxManagement/rfp/add-to-rfp',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/add-vendors-to-rfp', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Upload feedback
export const UploadFeedbackAsync = createAsyncThunk(
  'rfxManagement/rfp/upload-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//Upload FeedBack for multiple Sheet and Single standard sheet
export const UploadFeedbackForMultipleSheetAsync = createAsyncThunk(
  'rfxManagement/rfp/upload-feedback-for-multiple-sheet',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/upload-rfp-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//download zip for multipleSheet In Feedback
export const exportFeedbackMultipleVendors = createAsyncThunk(
  'rfxManagement/rfp/v1/rfp-analysis/export-feedback-multiple-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/export-feedback-multiple-vendors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//save configuration Data of the feedback file
export const saveConfigurationForFeedbackAsync = createAsyncThunk(
  'rfxManagement/rfp/save-configuration-for-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/submit-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getMultipleSheetDownloadFilesData = createAsyncThunk(
  'rfxManagement/rfp/api/v1/rfp-analysis/export-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/export-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//vendor-file-list
export const VendorFileList = createAsyncThunk(
  'rfxManagement/rfp/vendor-file-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/vendor-file-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Attached bid sheet list
export const getBidSheetList = createAsyncThunk(
  'rfxManagement/rfp/get-rfp-templates-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-templates-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//download-files
export const DownloadFilesAsync = createAsyncThunk(
  'rfxManagement/rfp-analysis/download-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-files',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

//download-rfp-bidSheets
export const DownloadBidSheetFiles = createAsyncThunk(
  'rfxManagement/rfp/download-rfp-templates-lis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-rfp-templates-list',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

//delete additional files
export const DeleteAdditionalFiles = createAsyncThunk(
  'rfxManagement/rfp/delete_file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/delete_file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//change round
export const ChangeRound = createAsyncThunk(
  'rfxManagement/rfp/update-rounds-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/update-rounds-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// upload RFP and additional files
export const UploadFilesAsync = createAsyncThunk(
  'rfxManagement/rfp-analysis/upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-files', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectedWithValue: true,
    })
  },
)

export const UploadFilesAsyncv2 = createAsyncThunk(
  'rfxManagement/rfp-analysis/upload-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-files_v2', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectedWithValue: true,
    })
  },
)

//list-request-for-vendors
export const getRequestVendorList = createAsyncThunk(
  'rfxManagement/rfp/list-request-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/list-request-for-vendor', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//approve-request-for-vendor-request
export const approveVandorRequest = createAsyncThunk(
  'rfxManagement/rfp/approve-request-for-multiple-contacts',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/approve-request-for-multiple-contacts',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//Get filled bid sheet for vendor
export const GetContactDetailsforVendorAsync = createAsyncThunk(
  'rfxManagement/rfp/get-contact-details-for-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-project-contacts', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get filled bid sheet for vendor
export const UpdateContactforVendorAsync = createAsyncThunk(
  'rfxManagement/rfp/update-contatct-for-vendor',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/add-rfp-contact', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Upload or select rfp bid sheet, additional files
export const uploadRfpTemplatesAsync = createAsyncThunk(
  'rfxManagement/rfp/uploadTemplates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/upload-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Upload or select rfp bid sheet, additional files
export const uploadRfpTemplatesAsyncv2 = createAsyncThunk(
  'rfxManagement/rfp/uploadTemplates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/upload-template_v2', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Get rfp templates and additional files for RFP project
export const getRFPTemplatesListAsync = createAsyncThunk(
  'rfxManagement/rfp/getRFPTemplatesListAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get common URL
export const getCommonURL = createAsyncThunk(
  'rfxManagement/rfp/generate-common-url',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/generate-common-url', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Change status
export const ChangeStatus = createAsyncThunk(
  'rfxManagement/rfp/change-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/change-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get rfp templates and additional files for RFP project
export const downloadBidTemplateAsync = createAsyncThunk(
  'rfxManagement/rfp/download-bidsheet-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/download-blob-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Delete RFP vendors from project
export const deleteRFPVendorsFromProjectAsync = createAsyncThunk(
  'rfxManagement/rfp/delete-RFP-vendors-from-project',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/delete-vendor', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Download Feedback Template for RFP
export const downloadRFPFeedbackTemplateAsync = createAsyncThunk(
  'rfxManagement/rfp/download-RFP-feedback-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfp-analysis/download-file', [], {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Check RFP Feedback Status
export const checkRFPFeedbackStatusAsync = createAsyncThunk(
  'rfxManagement/rfp/check-RFP-feedback-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/check-feedback-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getFeedbackValidationTable = createAsyncThunk(
  'rfxManagement/rfp/getFeedbackValidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-feedback-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const downloadAllFeedbackValidation = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/download-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      'v1/rfp-analysis/download-feedback',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)
export const downloadVendorFeedbackValidation = createAsyncThunk(
  'rfxManagement/rfp/feedback-generation/download-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/download-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Send RFP feedback mail to vendors
export const sendRFPFeedbackMailtoVendorsAsync = createAsyncThunk(
  'rfxManagement/rfp/send-RFP-feedback-mail-to-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v2/rfp-analysis/send-rfp-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Get generated feedback
export const getGeneratedFeedback = createAsyncThunk(
  'rfxManagement/rfp/get-generated-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/generate-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Change default mail template
export const changeDefaultTemplate = createAsyncThunk(
  'rfxManagement/rfp/default-email-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/default-email-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Change default mail template
export const getDefaultTemplate = createAsyncThunk(
  'rfxManagement/rfp/get-email-templates',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/get-email-templates', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      // isRejectWithErrorMsg: true,
    })
  },
)

export const getSheetsNamesForConsolidation = createAsyncThunk(
  'rfpAnalysis/getSheetsNamesForConsolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfp-analysis/get-sheets-names-for-consolidation',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      return rejectWithValue(error.message)
    }
  },
)

export const getConsolidationFilePath = createAsyncThunk(
  'rfpAnalysis/getConsolidationFilePath',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfp-analysis/get-consolidation-filepath',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      console.error('Error fetching consolidation file path:', error)
      return rejectWithValue(error.message)
    }
  },
)

export const downloadConsolidation = createAsyncThunk(
  'rfpAnalysis/downloadConsolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await AxiosClient(
        'POST',
        '/v1/rfp-analysis/download_consolidation',
        payload,
        { dispatch, rejectWithValue, fulfillWithValue },
      )
      return response
    } catch (error) {
      console.error('Error downloading consolidation file:', error)
      return rejectWithValue(error.message)
    }
  },
)

// Calculate feedback
export const calculateFeedbackAsync = createAsyncThunk(
  'rfpAnalysis/calculate-feedback',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/calculate-feedback', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get feedback files
export const getFeedbackFilesAsync = createAsyncThunk(
  'rfpAnalysis/get-feedback-files',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-feedback-files', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Get feedback files
export const downloadConsolidationAsync = createAsyncThunk(
  'rfpAnalysis/download-consolidation',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/download_consolidation', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Get All Question for RFP
export const getAllQuestionForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/all-question-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-all-questions-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
//get All Consolidated for RFP

export const getAllConsolidatedQuestionForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/all-consolidated-question-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/get-consolidated-question', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//sendRFPEmailAsync

export const sendQnARFPEmailAsync = createAsyncThunk(
  'rfxManagement/rfp-analysis/qna-email-notification',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/qna-email-notification', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//edit question-answer for RFP module
export const editAnswerForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/edit-answer-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/update-answer-for-question', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const editConsolidatedAnswerForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/edit-consolidated-answer-for-Async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/update-consolidated-question', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//download question answer template excel for RFP module
export const downloadQuestionAnswerExcel = createAsyncThunk(
  'rfp-analysis/download-question-answer-excel',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/download-question-answer-excel', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// Upload Vendors
export const uploadRfpConfigurationAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/upload-rfp-configuration',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-rfp-analysis-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const downloadRfpConfigTemplate = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/download-rfp-configuration-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfp-analysis/download-rfp-analysis-template', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// get field cofigurations data
export const getFieldConfigurationsData = createAsyncThunk(
  'rfxManagement/rfp/project-details/get-field-configuration',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-file-header-mapping', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// save field cofigurations
export const saveFieldsConfiguration = createAsyncThunk(
  'rfxManagement/rfp/project-details/save-field-configurations',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/save-field-configuration', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
// Get RFP analysis logs
export const rfpAnalysisLogsAsync = createAsyncThunk(
  'rfp-analysis/rfp-analysis-logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-rfp-logs', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Validate project for bid analysis
export const validateProjectAsync = createAsyncThunk(
  'rfp-analysis/validate-project',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/validate-project', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Run bid analysis
export const runBidAnalysisAsync = createAsyncThunk(
  'rfp-analysis/run-analysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/generate-rfp-analysis', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// Run custom bid analysis
export const runCustomScenarioBidAnalysisAsync = createAsyncThunk(
  'rfp-analysis/run-and-upload-custom-bid-analysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/upload-custom-bid-analysis-template',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)
//Reminder in rfp get event dropdown data

export const getAllEventDropDownDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/event-dropdowndata-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', 'v1/rfp-analysis/events', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// submit in rfp add reminder data
export const addNewRemainderDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/add-new-reminder-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/set-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//update reminder for rfp
export const updateRemainderDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/update-reminder-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/update-reminders', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//getAll reminders table data

export const getAllRemindersDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/get-reminder-data-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `v1/rfp-analysis/get-reminders`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//delete reminders

export const deleteRemindersDataForRFPAsync = createAsyncThunk(
  'rfxManagement/rfp/delete-reminder-data-for-RFPAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `v1/rfp-analysis/delete-reminders`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Get scenario list custom scenario in bid analysis
export const getReferenceScenarioList = createAsyncThunk(
  'rfp-analysis/custom-scenario/reference-custom-scenario-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-custom-scenario-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
// Download shortlist bidder template in bid analysis
export const downloadShortlistBidderTemplate = createAsyncThunk(
  'rfp-analysis/custom-scenario/download-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-shortlist-bidder-template',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Download last uploaded file for bid analysis configuration
export const downloadLastUploadedRFPConfigFile = createAsyncThunk(
  'rfp-analysis/baseline-upload/download-last-uploaded-file',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-bid-analysis-updated-file',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

// Set RFP configuration from last round
export const setRFPConfigFromLastRound = createAsyncThunk(
  'rfp-analysis/baseline-upload/rfp-config-from-last-round',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/get-rfp-bid-analysis-last-updated',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//email status tracker

export const getRFPVendorEmailStatus = createAsyncThunk(
  'rfp-analysis/get-mail-data-for-vendors',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-mail-data-for-vendors', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//Refresh status
export const refreshRFPVendorEmailStatus = createAsyncThunk(
  'rfp-analysis/refresh-mail-status',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/refresh-mail-status', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// Upload Intermediate file
export const uploadIntermediateFile = createAsyncThunk(
  'rfp-analysis/intermediate-file/upload',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/upload-intermediate-file', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// Generate intermediate file
export const generateIntermediateFile = createAsyncThunk(
  'rfp-analysis/intermediate-file/generate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/trigger-intermediate-file-analysis',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

// Get intermediate file logs
export const getIntermediateFileLogs = createAsyncThunk(
  'rfp-analysis/intermediate-file/logs',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/get-intermediate-file-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getProjectAndScenarioNamesBidAnalysisAsync = createAsyncThunk(
  'bid-analysis/get-project-and-scenario-names',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', '/v1/rfp-analysis/get-project-scenario-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const insertDeleteTagsAsync = createAsyncThunk(
  'bid-analysis/get-insert-update-tags-async',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/rfp-analysis/add-vendor-tags', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getBidAnalysisHistoryAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/get-latest-baseline-approve',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/get-latest-baseline-approve', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const uploadBidAnalysisProofAsync = createAsyncThunk(
  'rfxManagement/rfp/rfp-analysis/upload-proof-of-approval',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', 'v1/rfp-analysis/upload-baseline-approval-proof', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const downloadBidAnalysisFiles = createAsyncThunk(
  'rfxManagement/rfp/create-project-download-rfp-templates-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/download-rfp-templates-list',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
      'blob',
    )
  },
)

export const getBidSheetHistory = createAsyncThunk(
  'rfxManagement/rfp/get-bidSheet-history',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/rfp-analysis/get-rfp-templates-list-with-history',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)
